import { FC } from "react";

export const WASD: FC = () => {
  return (
     <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={34}
    fill="none"
  >
    <path
      fill="#E3E5FA"
      d="M15.667 0A4.333 4.333 0 0 1 20 4.333v7.334A4.333 4.333 0 0 1 15.667 16H8.333A4.333 4.333 0 0 1 4 11.667V4.333A4.333 4.333 0 0 1 8.333 0h7.334Zm-3.732 5c-.852 0-1.556.27-2.11.808-.257.245-.46.542-.61.888A2.73 2.73 0 0 0 9 7.768c0 .752.25 1.395.752 1.928.544.587 1.285.88 2.224.88.511 0 .979-.114 1.4-.344l.448.512 1.272-.192-.92-.944c.208-.202.37-.445.488-.728.144-.336.216-1.072.216-1.072 0-.81-.275-1.48-.824-2.008a2.68 2.68 0 0 0-.968-.592A3.286 3.286 0 0 0 11.936 5Zm0 1.344c.182 0 .37.04.561.12.197.075.365.182.504.32.133.133.237.29.312.472a1.29 1.29 0 0 1-.128 1.304l-.368-.4-1.304.168.848.848c-.149.037-.294.056-.432.056-.438 0-.798-.136-1.08-.408a1.285 1.285 0 0 1-.4-.968c0-.415.144-.773.432-1.072.282-.293.634-.44 1.055-.44Z"
    />
    <path
      fill="#E3E5FA"
      fillRule="evenodd"
      d="M26.333 0A4.333 4.333 0 0 0 22 4.333v7.334A4.333 4.333 0 0 0 26.333 16h7.334A4.333 4.333 0 0 0 38 11.667V4.333A4.333 4.333 0 0 0 33.667 0h-7.334Zm6.094 11 1.464-5.616h-1.472l-.816 4.088-.96-4.088h-1.504l-1 4.088-.808-4.088h-1.464L27.29 11h1.656l.928-3.696L30.77 11h1.656Z"
      clipRule="evenodd"
    />
    <path
      fill="#E3E5FA"
      d="M51.667 0A4.333 4.333 0 0 1 56 4.333v7.334A4.333 4.333 0 0 1 51.667 16h-7.334A4.333 4.333 0 0 1 40 11.667V4.333A4.333 4.333 0 0 1 44.333 0h7.334ZM46 5v5.336h3.032V9.16h-1.648v-.92h1.56V7.064h-1.56v-.888h1.648V5H46ZM11.944 24.896l.696 2.056h-1.384l.688-2.056Z"
    />
    <path
      fill="#E3E5FA"
      fillRule="evenodd"
      d="M8.333 18A4.333 4.333 0 0 0 4 22.333v7.334A4.333 4.333 0 0 0 8.333 34h7.334A4.333 4.333 0 0 0 20 29.667v-7.334A4.333 4.333 0 0 0 15.667 18H8.333Zm2.227 11 .336-.992h2.096l.336.992h1.448l-2.032-5.616H11.16L9.128 29h1.432ZM26.333 18A4.333 4.333 0 0 0 22 22.333v7.334A4.333 4.333 0 0 0 26.333 34h7.334A4.333 4.333 0 0 0 38 29.667v-7.334A4.333 4.333 0 0 0 33.667 18h-7.334Zm2.758 10.856c.325.133.693.2 1.104.2.421 0 .786-.077 1.096-.232.309-.155.544-.363.704-.624.165-.261.248-.552.248-.872 0-.336-.083-.61-.248-.824a1.672 1.672 0 0 0-.592-.488 7.121 7.121 0 0 0-.88-.352c-.363-.117-.63-.227-.8-.328-.171-.101-.256-.243-.256-.424 0-.165.05-.29.152-.376a.577.577 0 0 1 .4-.136c.192 0 .349.053.472.16.122.101.189.243.2.424h1.48c-.027-.528-.23-.939-.608-1.232-.379-.299-.878-.448-1.496-.448-.608 0-1.102.15-1.48.448-.379.293-.568.701-.568 1.224 0 .352.082.637.248.856.165.219.362.384.592.496.121.06.262.119.42.178.142.053.297.105.468.158.25.075.442.141.576.2.138.059.253.133.344.224.096.09.144.205.144.344a.48.48 0 0 1-.176.392c-.118.09-.278.136-.48.136a.705.705 0 0 1-.48-.16c-.123-.112-.195-.272-.216-.48h-1.456c.01.368.112.683.304.944.197.261.458.459.784.592Z"
      clipRule="evenodd"
    />
    <path
      fill="#E3E5FA"
      d="M48.72 27.392c-.288.283-.69.424-1.208.424h-.648v-3.264h.648c.517 0 .92.144 1.208.432.288.288.432.69.432 1.208 0 .517-.144.917-.432 1.2Z"
    />
    <path
      fill="#E3E5FA"
      fillRule="evenodd"
      d="M44.333 18A4.333 4.333 0 0 0 40 22.333v7.334A4.333 4.333 0 0 0 44.333 34h7.334A4.333 4.333 0 0 0 56 29.667v-7.334A4.333 4.333 0 0 0 51.667 18h-7.334Zm4.819 5.736c-.443-.235-.96-.352-1.552-.352h-2.104V29H47.6c.587 0 1.101-.117 1.544-.352a2.47 2.47 0 0 0 1.032-.992c.245-.427.368-.915.368-1.464 0-.555-.123-1.043-.368-1.464a2.48 2.48 0 0 0-1.024-.992Z"
      clipRule="evenodd"
    />
  </svg>
  );
};
